import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of as observableOf } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { HideModalReason } from '®shared/modals';
import { ReadingListService } from '®shared/reading-list/models';

import {
  DeleteListAction,
  DeleteListActionTypes,
  DeleteListFailedAction,
  DeleteListHideModalAction,
  DeleteListSucceededAction,
} from './delete-list.actions';

@Injectable()
export class DeleteListEffects {
  deleteList$: Observable<DeleteListSucceededAction | DeleteListFailedAction> =
    createEffect(() =>
      this.actions$.pipe(
        ofType(DeleteListActionTypes.DELETE_LIST),
        switchMap((action: DeleteListAction) => {
          const { listId } = action.payload;
          return this.readingListService.deleteList(listId).pipe(
            map(() => new DeleteListSucceededAction(action.payload)),
            catchError(error =>
              observableOf(
                new DeleteListFailedAction({
                  ...action.payload,
                  error,
                }),
              ),
            ),
          );
        }),
      ),
    );

  deleteListSuccess$: Observable<DeleteListHideModalAction> = createEffect(() =>
    this.actions$.pipe(
      ofType(DeleteListActionTypes.DELETE_LIST_SUCCEEDED),
      map(
        (action: DeleteListSucceededAction) =>
          new DeleteListHideModalAction({
            listId: action.payload.listId,
            reason: HideModalReason.COMPLETED,
          }),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private readingListService: ReadingListService,
  ) {}
}
